import { render, staticRenderFns } from "./PastSectionStudent.vue?vue&type=template&id=e930e974&scoped=true"
import script from "./PastSectionStudent.vue?vue&type=script&lang=js"
export * from "./PastSectionStudent.vue?vue&type=script&lang=js"
import style0 from "./PastSectionStudent.vue?vue&type=style&index=0&id=e930e974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e930e974",
  null
  
)

export default component.exports